// src/config/apiConfig.js

// Prefer an explicit env var. Fallbacks are useful for local emulators or proxying.
const RAW_BASE =
  import.meta.env.VITE_API_BASE?.replace(/\/+$/, '') ||
  // If you proxy /api/* to your Cloud Function in dev, you can use '' and prepend /api below.
  '' // empty = same-origin

// Final helper to build URLs consistently.
export const apiBase = (path = '') => {
  // If RAW_BASE is empty, we assume a same-origin proxy like `/api/...`
  if (!RAW_BASE) {
    return `/api${path.startsWith('/') ? path : `/${path}`}`
  }
  return `${RAW_BASE}${path.startsWith('/') ? path : `/${path}`}`
}

// Default request timeouts (ms)
export const DEFAULT_TIMEOUT = 25_000

// Storage keys (localStorage)
export const STORAGE_KEYS = {
  researcherKey: 'researcher_key', // X-API-Key
  adminKey: 'admin_key',           // admin’s API key (role=admin in Firestore)
  adminSecret: 'admin_secret',     // admin secret (from admin_secrets/config)
}
